import { User } from '../../core/declarations/user.interface';
import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { getCurrentUser } from '../../core/states/user-state/user.selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TermsAcceptedGuard {
  constructor(
    private userStore: Store<User>,
    private router: Router
  ) {}

  canActivateChild(
    _: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.userStore.select(getCurrentUser).pipe(
      filter(x => x !== null),
      map(user => user as User),
      map(user => {
        if (user.terms_accepted) {
          return true;
        } else {
          // keep the target, e.g. a QR code link, for after accepting
          return this.router.createUrlTree(['/terms-and-conditions'], {
            queryParams: { redirectTo: routerState.url }
          });
        }
      })
    );
  }
}

export const termsAcceptedGuard: CanActivateFn = (_, state) => {
  const userStore = inject(Store);
  const router = inject(Router);

  return userStore.select(getCurrentUser).pipe(
    filter(x => x !== null),
    map(user => user as User),
    map(user => {
      if (user.terms_accepted) {
        return true;
      } else {
        return router.createUrlTree(['/terms-and-conditions'], {
          queryParams: { redirectTo: state.url }
        });
      }
    })
  );
};
